import { safeFormatISODate } from 'shared/util/datetime-fns';
import type { CarState } from '../search/car/carDefaultState';

export const buildCarTrackingItem = (state: Partial<CarState>) => ({
    id: 'finntravel',
    type: 'Travel',
    destination: state.pickupLocation,
    travelType: 'carrental',
    departureDate: `${safeFormatISODate(state.pickupDate)}T${state.pickupTime}:00.000Z`,
    returnDate: `${safeFormatISODate(state.returnDate)}T${state.returnTime}:00.000Z`,
});
